

import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'



/* Hooks */
import useFlashMessage from '../../../../hooks/useFlashMessage'

/* form */
import FormBudgetSimpleItem from './Form/FormBudgetSimpleItem'
import RandomString from '../../../../shared/functions/RandomString'

function NewBudgetSimpleItem({ btCancelAction, handleOnSuccess, handleOnEditItem, clientId, item }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()




    function EditBudgetItem(budgetItem) {



        handleOnEditItem(budgetItem)

    }

    return (
        <FormBudgetSimpleItem title="Editar Item" clientId={clientId} itemData={item} handleSubmit={EditBudgetItem} btCancelAction={btCancelAction} btnText="Concluir" btnVariant="finish" handleOnSuccess={handleOnSuccess} />
    )
}

export default NewBudgetSimpleItem